import {useInView} from 'react-intersection-observer';
import React, {useContext, useEffect} from 'react';
import classNames from 'classnames';
import TheCounterContext, {Category} from './TheCounterContext';

type TheCounterCategoriesProps = {
  categories: Category[];
};

const TheCounterCategories = ({categories}: TheCounterCategoriesProps) => {
  const [selected, setSelected] = useContext(TheCounterContext);
  const {ref, inView} = useInView();

  // first category auto select
  useEffect(() => {
    if (selected == null && categories && categories[0]) setSelected(categories[0]);
  }, [categories, selected]);

  return (
    <>
      <div ref={ref} className='TheCounterCategories__anchor' />
      <ul className={classNames('TheCounterCategories__categories', {stucked: !inView})}>
        {categories?.map((category) => (
          <li
            key={category.id}
            className={classNames({active: selected === category && categories.length > 1})}
            onClick={() => setSelected(category)}>
            {category.name}
          </li>
        ))}
      </ul>
    </>
  );
};

export default TheCounterCategories;
